export default __webpack_public_path__ + "static/media/sitepoint.797a9bfa.png";